import React, { useEffect, useState, useCallback,useContext } from 'react';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-buttons-dt/js/buttons.dataTables.js';
import 'jszip/dist/jszip.min.js';
import 'pdfmake/build/pdfmake.min.js';
import 'pdfmake/build/vfs_fonts.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { Icon } from '@iconify/react/dist/iconify.js';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';    
import { LoginContext } from "../AuthContext/LoginContext";
import TooltipTextPopupCustom from './child/TooltipTextPopupCustom';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';


const CustomRescuersTableLayer = () => {
    const [rescuers, setRescuers] = useState([]);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [selectedRescuer, setSelectedRescuer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedType, setSelectedType] = useState('All');
    //const [dataTable, setDataTable] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    const navigate = useNavigate();
    const { hasPermission } = useContext(LoginContext);

    const fetchRescuers = useCallback(async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(`${API_BASE_URL}/backend/rescuers/get-all-rescuers`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (response.data.status) {
                setRescuers(response.data.data);
            } else {
                toast.error("Failed to fetch rescuers.");
            }
        } catch (error) {
            console.error("Error fetching rescuers:", error);
            toast.error("Error fetching rescuers.");
        } finally {
            setLoading(false);
        }
    }, [API_BASE_URL]);

    useEffect(() => {
        fetchRescuers();
    }, [fetchRescuers]);

    const applyFilter = useCallback((type, table) => {
        if (type === 'All') {
            table.columns(10).search('').draw();
        } else {
            table.columns(10).search(type).draw();
        }
    }, []);

    
    useEffect(() => {
        if (rescuers.length > 0) {
            if ($.fn.DataTable.isDataTable('#dataTable')) {
                $('#dataTable').DataTable().destroy();
            }

            const table = $('#dataTable').DataTable({
                dom: 'Bfrtip',
                buttons: [
                    {
                        extend: 'csv',
                        text: '<i class="iconify" data-icon="mdi:file-delimited-outline"></i> CSV',
                        className: 'btn btn-primary btn-sm',
                        exportOptions: {
                            columns: ':visible'
                        }
                    },
                    
                    'colvis'
                ],
                pageLength: 10,
                responsive: true,
                destroy: true,
            });

            //setDataTable(table);
            applyFilter(selectedType, table);
        }

        return () => {
            if ($.fn.DataTable.isDataTable('#dataTable')) {
                $('#dataTable').DataTable().destroy();
            }
        };
    }, [rescuers, selectedType, applyFilter]);

    const exportToCSV = () => {
        $('#dataTable').DataTable().button('.buttons-csv').trigger();
    };
    
    // const exportToExcel = () => {
    //     $('#dataTable').DataTable().button('.buttons-excel').trigger();
    // };
    
    const exportToPDF = (tableSelector = '#dataTable', fileNamePrefix = 'CMS_Export') => {
        try {
            const table = $(tableSelector).DataTable();
            if (!table) throw new Error("Table not found or not initialized.");
    
            const skipColumnTitles = ['Action'];
            const headers = [];
            const includedIndexes = [];
    
            // 1. Get visible and valid headers
            table.columns().every(function(index) {
                if (this.visible()) {
                    const column = this;
                    const headerEl = column.header();
                    const headerText = headerEl?.textContent?.trim() || `Column ${index + 1}`;
    
                    if (!skipColumnTitles.includes(headerText)) {
                        headers.push({ title: headerText, index });
                        includedIndexes.push(index);
                    }
                }
                return true;
            });
    
            // 2. Get filtered and sorted data
            const pdfData = [];
            table.rows({ filter: 'applied' }).every(function () {
                const rowEl = this.node(); // Get the actual DOM node for the row
                const cells = rowEl.children;
                const rowValues = [];
    
                includedIndexes.forEach(i => {
                    const cell = cells[i];
                    if (!cell) {
                        rowValues.push('');
                        return;
                    }
    
                    // Get clean visible text without HTML
                    const text = cell.innerText?.trim() || '';
                    rowValues.push(text);
                });
    
                pdfData.push(rowValues);
                return true;
            });
    
            // 3. Create PDF
            const doc = new jsPDF({
                orientation: pdfData.length > 0 && pdfData[0].length > 5 ? 'landscape' : 'portrait',
                unit: 'mm'
            });
    
            const now = new Date();
            const timestamp = now.toISOString()
                .replace(/T/, '_')
                .replace(/\..+/, '')
                .replace(/:/g, '-');
            const fileName = `${fileNamePrefix}_${timestamp}`;
    
            // 4. Title and meta
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(16);
            doc.text(`${fileNamePrefix} Report`, 14, 10);
    
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);
            doc.text(`Generated: ${now.toLocaleString()}`, 14, 15);
            doc.text(`Total Records: ${pdfData.length}`, 14, 20);
    
            // 5. Table
            autoTable(doc, {
                startY: 25,
                head: [headers.map(h => h.title)],
                body: pdfData,
                styles: {
                    fontSize: 8,
                    cellPadding: 2,
                    overflow: 'linebreak',
                    halign: 'left'
                },
                headStyles: {
                    fillColor: [41, 128, 185],
                    textColor: 255,
                    fontStyle: 'bold',
                    halign: 'center'
                },
                margin: {
                    top: 25,
                    left: 10,
                    right: 10
                }
            });
    
            // 6. Page numbers
            const pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.setFontSize(8);
                doc.text(
                    `Page ${i} of ${pageCount}`,
                    doc.internal.pageSize.width - 20,
                    doc.internal.pageSize.height - 10
                );
            }
    
            doc.save(`${fileName}.pdf`);
        } catch (error) {
            console.error("PDF Export Error:", error);
            toast.error("Failed to generate PDF. Please try again.");
        }
    };
    
    
    // const printTable = () => {
    //     $('#dataTable').DataTable().button('.buttons-print').trigger();
    // };
    
    const handleTypeChange = (e) => {
        setSelectedType(e.target.value);
    };

    const handleShowDetailsModal = (rescuer) => {
        setSelectedRescuer(rescuer);
        setShowDetailsModal(true);
    };

    const handleEditRescuer = (rescuerId) => {
        navigate(`/rescuers/update/${rescuerId}`);
    };

    const handleShowDeleteModal = (rescuer) => {
        setSelectedRescuer(rescuer);
        setShowDeleteModal(true);
    };

    const handleDeleteRescuer = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.patch(
                `${API_BASE_URL}/backend/rescuers/delete/${selectedRescuer._id}`,
                {}, 
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            if (response.data.status) {
                toast.success("Rescuer deleted successfully.");
                fetchRescuers();
            } else {
                toast.error("Failed to delete rescuer.");
            }
        } catch (error) {
            console.error("Error deleting rescuer:", error);
            toast.error("Error deleting rescuer.");
        } finally {
            setShowDeleteModal(false);
        }
    };

    return (
        <div className="card basic-data-table">
            <ToastContainer />
            
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Rescuers Data</h5>
                <div className="export-buttons d-flex align-items-center">
                        <button onClick={exportToCSV} className="btn btn-success btn-sm me-2 d-flex align-items-center">
                            <Icon icon="mdi:file-delimited-outline" className="me-1" style={{ fontSize: '16px' }} /> 
                            CSV
                        </button>
                        {/* <button onClick={exportToExcel} className="btn btn-primary btn-sm me-2 d-flex align-items-center">
                            <Icon icon="mdi:microsoft-excel" className="me-1" style={{ fontSize: '16px' }} /> 
                            Excel
                        </button> */}
                        <button onClick={() => exportToPDF('#dataTable', 'Rescuers_Export')}  className="btn btn-danger btn-sm me-2 d-flex align-items-center">
                            <Icon icon="mdi:file-pdf-box" className="me-1" style={{ fontSize: '16px' }} /> 
                            PDF
                        </button>
                        {/* <button onClick={printTable} className="btn btn-info btn-sm d-flex align-items-center">
                            <Icon icon="mdi:printer" className="me-1" style={{ fontSize: '16px' }} /> 
                            Print
                        </button> */}
                    </div>
                <div className="d-flex align-items-center gap-3">
                    <span className="text-md fw-medium text-secondary-light mb-0">Type</span>
                    <select 
                        className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px" 
                        value={selectedType}
                        onChange={handleTypeChange}
                    >
                        <option value="All">All</option>
                        <option value="Volunteer">Volunteer</option>
                        <option value="Fire Fighter">Fire Fighter</option>
                        <option value="Fire Watchers">Fire Watchers (Rakhas)</option>
                    </select>
                </div>
            </div>
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table bordered-table mb-0" id="dataTable" data-page-length={10}>
                        <thead>
                            <tr>
                                <th scope="col">S.L</th>
                                <th scope="col">Division</th>
                                <th scope="col">Sub Division</th>
                                <th scope="col">Block</th>
                                <th scope="col">CPT No</th>
                                <th scope="col">Rescuer Name</th>
                                <th scope="col">Parentage</th>
                                <th scope="col">Address</th>
                                <th scope="col">Contact No</th>
                                <th scope="col">CNIC No</th>
                                <th scope="col">Type</th>
                                <th scope="col">Coordinates</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                Array.from({ length: 10 }).map((_, index) => (
                                    <tr key={index}>
                                        <td><Skeleton width={30} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={120} /></td>
                                        <td><Skeleton width={120} /></td>
                                        <td><Skeleton width={150} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={30} /></td>
                                    </tr>
                                ))
                            ) : rescuers && rescuers.length > 0 ? (
                                rescuers.map((rescuer, index) => (
                                    <tr key={rescuer._id}>
                                        <td>{index + 1}</td>
                                        <td>{rescuer.division || 'No Data Found'}</td>
                                        <td>{rescuer.sub_division || 'No Data Found'}</td>
                                        <td>{rescuer.block || 'No Data Found'}</td>
                                        <td>{rescuer.cpt_no || 'No Data Found'}</td>
                                        <td>{rescuer.rescuer_name || 'No Data Found'}</td>
                                        <td>{rescuer.parentage || 'No Data Found'}</td>
                                        <td>
                                        <TooltipTextPopupCustom 
                                                text={rescuer.rescuer_address}
                                                truncateLength={16} 
                                                placement="left"
                                                customClass="tooltip-info" />
                                        </td>
                                        <td>{rescuer.rescuer_contact_no || 'No Data Found'}</td>
                                        <td>{rescuer.rescuer_cnic_no || 'No Data Found'}</td>
                                        <td>{rescuer.rescuer_type || 'No Data Found'}</td>
                                        <td>
                                            {rescuer.rescuer_coordinates ? 
                                                `Lat: ${rescuer.rescuer_coordinates.latitude}, Lon: ${rescuer.rescuer_coordinates.longitude}` : 
                                                'No Data Found'}
                                        </td>
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                            {hasPermission('rescuers', 'view') && (
                                                <button
                                                    type="button" 
                                                    onClick={() => handleShowDetailsModal(rescuer)}
                                                    className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon
                                                        icon="majesticons:eye-line"
                                                        className="icon text-xl"
                                                    />
                                                </button>
                                            )}
                                            {hasPermission('rescuers', 'edit') && (
                                                <button
                                                    type="button" 
                                                    onClick={() => handleEditRescuer(rescuer._id)}
                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon icon="lucide:edit" className="menu-icon" />
                                                </button>
                                            )}
                                              {hasPermission('rescuers', 'delete') && (
                                                <button
                                                    type="button"
                                                    onClick={() => handleShowDeleteModal(rescuer)}
                                                    className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon
                                                        icon="fluent:delete-24-regular"
                                                        className="menu-icon"
                                                    />
                                                </button>
                                              )}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="13" className="text-center">No rescuers found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Rescuer Details Modal */}
            <Modal  show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Rescuer Details</Modal.Title>
                </Modal.Header>
                <Modal.Body className='watermark'>
                    {selectedRescuer && (
                        <div>
                            <p><strong>Rescuer Name:</strong> {selectedRescuer.rescuer_name}</p>
                            <p><strong>Parentage:</strong> {selectedRescuer.parentage}</p>
                            <p><strong>Address:</strong> {selectedRescuer.rescuer_address}</p>
                            <p><strong>Contact No:</strong> {selectedRescuer.rescuer_contact_no}</p>
                            <p><strong>CNIC No:</strong> {selectedRescuer.rescuer_cnic_no}</p>
                            <p><strong>Type:</strong> {selectedRescuer.rescuer_type}</p>
                            <p><strong>Coordinates:</strong> Lat: {selectedRescuer.rescuer_coordinates?.latitude}, Lon: {selectedRescuer.rescuer_coordinates?.longitude}</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Address Modal */}
            <Modal show={showAddressModal} onHide={() => setShowAddressModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Rescuer Address</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedRescuer && (
                        <div>
                            <p>{selectedRescuer.rescuer_address || 'No address available'}</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowAddressModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete {selectedRescuer?.rescuer_name || 'this rescuer'}?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeleteRescuer}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CustomRescuersTableLayer;